<template>
  <a class="text-decoration-none" role="button" :aria-label="'Link to ' + publication.Title" :href="publication.DetailsUrl">
    <div class="d-flex flex-column publication-card">
      <div class="pb-4 mb-lg-3"><img class="publication-card_image" :src="publication.ImageUrl" /></div>
      <div class="d-flex justify-content-between">
        <span class="text-primary me-4 publication-card_title"><strong class="fs-6">{{topic}}</strong> <strong class="fs-6">{{publication.SubTopics}}</strong></span>
      </div>
      <h3 class="m-0"><strong>{{publication.Title}}</strong></h3>
      <span class="text-primary">{{publication.Author}}</span>
      <div class="publication-card_description mt-3" v-html="publication.Description"></div>
    </div>
  </a>
</template>
<script>

  export default {
    name: 'PublicationTopicCard',
    props: {
      publication: {
        type: Object,
        required: true
      }
    },
    setup(props) {
      let topic = "";

      if (props.publication.Topics != null && props.publication.Topics.length > 0) {
        topic = props.publication.Topics[0];
      }

      return {
        topic
      }
    }
  };
</script>
